import * as m from 'framer-motion/m'

const LEADERS = [
  {
    name: 'Anthony Abrams',
    role: 'CEO',
    bio: 'Leading Impact Real Estate Capital in investing in and developing high-quality real estate projects across the UK.',
    image: 'team/anthony',
  },
  {
    name: 'Shankar Manoharan',
    role: 'Head of Investment',
    bio: 'As Head of Investment at Impact Real Estate Capital, I work across the full investment lifecycle — from sourcing and evaluating opportunities to structuring deals, raising capital, and managing portfolios. We are an established, well-capitalised real estate investor with a focus on value-driven opportunities and long-term, sustainable growth.',
    image: 'team/shankar',
  },
] as const

export function Team() {
  return (
    <section className="bg-[#1e232b] border-t border-white/10" id="team">
      <div className="w-[92%] sm:w-[88%] md:w-[85%] lg:w-[80%] max-w-[1200px] mx-auto relative px-1 sm:px-0">
        <div className="py-12 sm:py-16 md:py-20">
          <m.h2
            className="uppercase text-[#cab6a1] text-[28px] sm:text-[36px] md:text-[48px] leading-[1.2em] font-serif mb-10 md:mb-14"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Our Team
          </m.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
            {LEADERS.map((person, i) => (
              <m.article
                key={person.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex flex-col sm:flex-row gap-6 items-start"
              >
                <div className="shrink-0 w-full sm:w-[200px] aspect-square max-w-[200px] rounded-lg overflow-hidden bg-white/80 border border-[#1e232b]/15">
                  <img
                    srcSet={`/assets/${person.image}-400.png 400w, /assets/${person.image}.png 800w`}
                    sizes="(max-width: 640px) 100vw, 200px"
                    src={`/assets/${person.image}.png`}
                    alt={`${person.name}, ${person.role}`}
                    loading="lazy"
                    decoding="async"
                    width={400}
                    height={400}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="font-serif text-white text-xl sm:text-2xl uppercase tracking-wide">{person.name}</h3>
                  <p className="text-[#cab6a1] text-sm sm:text-base mt-1 font-sans">{person.role}</p>
                  <p className="text-white/80 text-sm sm:text-[15px] mt-4 leading-relaxed whitespace-pre-line font-sans">{person.bio}</p>
                </div>
              </m.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
